var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46 2.874a.65.65 0 0 1 0 .919L4.903 7.35h7.764a.65.65 0 0 1 0 1.3H4.903l3.557 3.557a.65.65 0 0 1-.92.92L2.874 8.46a.65.65 0 0 1 0-.92L7.54 2.874a.65.65 0 0 1 .92 0Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjQ1OTYxIDIuODczNzFDOC43MTM0NSAzLjEyNzU2IDguNzEzNDUgMy41MzkxMSA4LjQ1OTYxIDMuNzkyOTVMNC45MDI1NiA3LjM1SDEyLjY2NjdDMTMuMDI1NiA3LjM1IDEzLjMxNjcgNy42NDEwMiAxMy4zMTY3IDhDMTMuMzE2NyA4LjM1ODk5IDEzLjAyNTYgOC42NSAxMi42NjY3IDguNjVINC45MDI1Nkw4LjQ1OTYxIDEyLjIwN0M4LjcxMzQ1IDEyLjQ2MDkgOC43MTM0NSAxMi44NzI0IDguNDU5NjEgMTMuMTI2M0M4LjIwNTc2IDEzLjM4MDEgNy43OTQyMSAxMy4zODAxIDcuNTQwMzcgMTMuMTI2M0wyLjg3MzcgOC40NTk2MkMyLjYxOTg2IDguMjA1NzggMi42MTk4NiA3Ljc5NDIyIDIuODczNyA3LjU0MDM4TDcuNTQwMzcgMi44NzM3MUM3Ljc5NDIxIDIuNjE5ODcgOC4yMDU3NiAyLjYxOTg3IDguNDU5NjEgMi44NzM3MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";